import React, { useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Button, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import CarrierDTO from '../../../../dto/CarrierDTO';
import { loadSZLTList, szltHelper, vehiclesHelper } from '../../../RegionRegistry/actions';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import { getDeepValue, responseLogWithNotification } from '../../../../utils/utils';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../configs';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import { RegistryNumberInput } from '../RegistryNumberInput';
import OsgopInsuranceForm from './OsgopInsuranceForm';
import RegistryNumberSelectorWithTextInput
  from '../../../../components/fields/SelectInput/RegistryNumberSelectorWithTextInput';
import CustomRegistryNumberSelector from '../../../../components/fields/SelectInput/CustomRegistryNumberSelector';

export default function ApplicationCarrierForm(props) {
  const {
    prefix, disabled, control, watch, selectedProcedure, legalEntityType, formMeta, setValue, numberHelperAction = _ => {
    }, procedure, labelPrefix, getValues, errors,
  } = props;
  const {
    fields: osgopFields, append: appendOsgop, remove: removeOsgop,
  } = useFieldArray({ control, name: 'osgop_insurances' });
  const {
    fields: vehicleNumbersAttachFields, append: appendVehicleNumbersAttach, remove: removeVehicleNumbersAttach,
  } = useFieldArray({ control, name: `${prefix}vehicles_attach` });
  const {
    fields: vehicleNumbersDetachFields, append: appendVehicleNumbersDetach, remove: removeVehicleNumbersDetach,
  } = useFieldArray({ control, name: `${prefix}vehicles_detach` });
  const dispatch = useDispatch();
  const [hasEmployees, setHasEmployees] = useState();
  const DTO = new CarrierDTO({ legal_entity_type: legalEntityType });
  const attributes = DTO.getAttributesByName();
  React.useEffect(() => {
    const subscription = watch(values => {
      setHasEmployees(getDeepValue(values, `${prefix}has_employees`));
      const driver_license_issue_date = getDeepValue(values, `${prefix}driver_license_issue_date`);
      const driver_license_expiration_date = getDeepValue(values, `${prefix}driver_license_expiration_date`);
      if (driver_license_issue_date && !driver_license_expiration_date) {
        const nv = moment(driver_license_issue_date, 'YYYY-MM-DD').add(10, 'year').format('YYYY-MM-DD');
        setValue(`${prefix}driver_license_expiration_date`, nv);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  React.useEffect(() => {
    const p1 = dispatch(loadSZLTList()).catch(responseLogWithNotification);
  }, []);
  const isProcedure1227_1 = selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1;
  const isProcedure1227_5 = selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5;

  const renderContractInfo = (selectedProcedure, control, attributes, prefix) => {
    if (!isProcedure1227_1 && !isProcedure1227_5) {
      return null;
    }

    return (
      <>
        <div className="f4 mt-3">Информация о договоре об обеспечении</div>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.carriage_contract_name}
            variant="material"
            namePrefix={prefix}
            formMeta={formMeta}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomRegistryNumberSelector}
            dtoObject={attributes.carriage_vehicle_number}
            variant="material"
            withLabel
            loadAction={vehiclesHelper}
            namePrefix={prefix}
            // onSelectNumber={onSelectNumber}
            optionFormatter={item => ({ value: item.number, name: item.number })}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.carriage_contract_number}
            disabled={(procedure === PROCEDURE_TYPE.PROCEDURE_1227_5 && legalEntityType === USER_TYPE.PRIVATE_PERSON)}
            variant="material"
            namePrefix={prefix}
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            changeFormat="YYYY-MM-DD"
            hideTime
            dtoObject={attributes.carriage_contract_effective_date}
            disabled={(procedure === PROCEDURE_TYPE.PROCEDURE_1227_5 && legalEntityType === USER_TYPE.PRIVATE_PERSON)}
            variant="material"
            withLabel
            namePrefix={prefix}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.carriage_contract_expiration_date}
            disabled={(procedure === PROCEDURE_TYPE.PROCEDURE_1227_5 && legalEntityType === USER_TYPE.PRIVATE_PERSON)}
            variant="material"
            hideTime
            withLabel
            namePrefix={prefix}
          />
        </Row>
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.carriage_file}
            namePrefix="media."
            variant="material"
            multiple
          />
        </Row>
      </>
    );
  };

  return (
    <>
      {isProcedure1227_1 && (legalEntityType === USER_TYPE.LEGAL || legalEntityType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR) ? null : (<div className="f4 mt-3">Номер разрешения перевозчика</div>) }
      {!isProcedure1227_1 ? (
        <Row className="row-cols-1">
          <RegistryNumberInput
            formMeta={formMeta}
            numberHelperAction={numberHelperAction}
            labelPrefix={labelPrefix}
            setValue={setValue}
            getValues={getValues}
            procedure={procedure}
            control={control}
            prefix={prefix}
          />
        </Row>
      ) : legalEntityType !== USER_TYPE.LEGAL && legalEntityType !== USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? (
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.expiration_date}
            variant="material"
            withLabel
            namePrefix={prefix}
          />
        </Row>
      ) : null}
      {
        selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5
          ? (
            <div className="form-list-block">
              {/* <div className="form-list-header f4 mt-3"> */}
              {/*  Номера договоров с СЗЛТ исключить от перевозчика */}
              {/*  <Button */}
              {/*    variant="link" */}
              {/*    onClick={() => orderServiceNumbersDetachAppend({ order_service_number: '' })} */}
              {/*  > */}
              {/*    Добавить запись */}
              {/*  </Button> */}
              {/* </div> */}
              {/* {orderServiceNumbersDetachFields.map((field, index) => ( */}
              {/*  <div className="carrier-szlt-registry mt-3" key={field.id}> */}
              {/*    <Row className="row-cols-1"> */}
              {/*      <FieldDTOWithCol */}
              {/*        control={control} */}
              {/*        formMeta={formMeta} */}
              {/*        type="text" */}
              {/*        component={RegistryNumberSelectorWithTextInput} */}
              {/*        dtoObject={{ */}
              {/*          ...attributes.order_service_numbers_detach, */}
              {/*          name: `${prefix}order_services_detach.${index}.order_service_number`, */}
              {/*        }} */}
              {/*        loadAction={szltHelper} */}
              {/*        variant="material" */}
              {/*        prefix={prefix} */}
              {/*        withLabel */}
              {/*      /> */}
              {/*    </Row> */}
              {/*    <div className="d-flex flex-row align-items-center"> */}
              {/*      <Button className="mt-3 ms-auto btn-link" onClick={() => removeOrderServiceNumbersDetach(index)}>Удалить */}
              {/*        запись */}
              {/*      </Button> */}
              {/*    </div> */}
              {/*  </div> */}
              {/* ))} */}
              <div className="mb-3" />
              <div className="form-list-block">
                <div className="form-list-header f4 mt-3">
                  Номера в реестре ЛТ включить к перевозчику
                  <Button
                    variant="link"
                    onClick={() => appendVehicleNumbersAttach({ vehicle_number: '' })}
                  >
                    Добавить запись
                  </Button>
                </div>
                {vehicleNumbersAttachFields.map((field, index) => (
                  <div className="carrier-szlt-registry mt-3" key={field.id}>
                    <Row className="row-cols-1">
                      <FieldDTOWithCol
                        control={control}
                        formMeta={formMeta}
                        type="text"
                        component={CustomRegistryNumberSelector}
                        dtoObject={{
                          ...attributes.vehicle_numbers_attach,
                          name: `${prefix}vehicles_attach.${index}.vehicle_number`,
                        }}
                        loadAction={vehiclesHelper}
                        variant="material"
                        prefix={prefix}
                        withLabel
                      />
                    </Row>
                    <div className="d-flex flex-row align-items-center">
                      <Button className="mt-3 ms-auto btn-link" onClick={() => removeVehicleNumbersAttach(index)}>Удалить
                        запись
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mb-3" />
              <div className="form-list-block">
                <div className="form-list-header f4 mt-3">
                  Номера в реестре ЛТ исключить от перевозчика
                  <Button
                    variant="link"
                    onClick={() => appendVehicleNumbersDetach({ vehicle_number: '' })}
                  >
                    Добавить запись
                  </Button>
                </div>
                {vehicleNumbersDetachFields.map((field, index) => (
                  <div className="carrier-szlt-registry mt-3" key={field.id}>
                    <Row className="row-cols-1">
                      <FieldDTOWithCol
                        control={control}
                        formMeta={formMeta}
                        type="text"
                        component={CustomRegistryNumberSelector}
                        dtoObject={{
                          ...attributes.vehicle_numbers_detach,
                          name: `${prefix}vehicles_detach.${index}.vehicle_number`,
                        }}
                        loadAction={vehiclesHelper}
                        variant="material"
                        prefix={prefix}
                        withLabel
                      />
                    </Row>
                    <div className="d-flex flex-row align-items-center">
                      <Button className="mt-3 ms-auto btn-link" onClick={() => removeVehicleNumbersDetach(index)}>Удалить
                        запись
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null
      }
      {legalEntityType === USER_TYPE.PRIVATE_PERSON ? renderContractInfo(selectedProcedure, control, attributes, prefix) : null}
      {
        selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5 ? (
          <div className="form-list-block">
            <div className="form-list-header f4 mt-3">
              Информация по ОСГОП перевозчика
              <Button
                variant="link"
                onClick={() => appendOsgop({
                  insurer: null,
                  insurance_contract_number: null,
                  insurance_contract_effective_date: null,
                  insurance_contract_expiration_date: null,
                  osgop_files: null,
                })}
              >
                Добавить запись
              </Button>
            </div>
            {osgopFields.map((field, index) => (
              <div className="carrier-szlt-registry mt-3" key={field.id}>
                <OsgopInsuranceForm
                  control={control}
                  formMeta={formMeta}
                  selectedProcedure={selectedProcedure}
                  labelPrefix="osgop_"
                  prefix="osgop_insurances."
                  disabled={disabled}
                  index={index}
                />
                <div className="d-flex flex-row align-items-center">
                  <Button className="mt-3 ms-auto btn-link" onClick={() => removeOsgop(index)}>Удалить
                    запись
                  </Button>
                </div>
              </div>
            ))}
          </div>
        ) : null
      }
      {
        selectedProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1
          ? (
            <div className="form-list-block">
              <div className="form-list-header f4 mt-3">
                Номер записи в реестре ЛТ
                <Button
                  variant="link"
                  onClick={() => appendVehicleNumbersAttach({ vehicle_number: '' })}
                >
                  Добавить запись
                </Button>
              </div>
              {errors?.application_carrier?.vehicles_attach?.message ? (<div className="invalid-feedback d-block mt-1">{errors?.application_carrier?.vehicles_attach?.message}</div>) : null }
              {vehicleNumbersAttachFields.map((field, index) => (
                <div className="carrier-szlt-registry mt-3" key={field.id}>
                  <Row className="row-cols-1">
                    <FieldDTOWithCol
                      control={control}
                      formMeta={formMeta}
                      type="text"
                      component={RegistryNumberSelectorWithTextInput}
                      dtoObject={{
                        ...attributes.vehicle_numbers_attach,
                        name: `${prefix}vehicles_attach.${index}.vehicle_number`,
                        labelKey: 'vehicles_attach',
                      }}
                      loadAction={vehiclesHelper}
                      variant="material"
                      prefix={prefix}
                      withLabel
                    />
                  </Row>
                  <div className="d-flex flex-row align-items-center">
                    <Button className="mt-3 ms-auto btn-link" onClick={() => removeVehicleNumbersAttach(index)}>Удалить запись</Button>
                  </div>
                </div>
              ))}
            </div>
          ) : null
      }
      <div className="mb-3" />
    </>
  );
}
